import PageCard from "features/shared/components/card/PageCard";
import FormGroup from "features/shared/forms/components/FormGroup";
import React from "react";
import { ContractingSubFormBaseProps } from "features/contracting/models/ContractingSubFormBaseProps";
import DatePicker from "features/shared/components/reactDates/DatePicker";
import DegreeDTO from "features/shared/dtos/DegreeDTO";
import InputGroup from "features/shared/forms/components/inputGroup/InputGroup";
import DegreeSelect from "./DegreeSelect";
import { getDateOfBirthMaxDate } from "features/contracting/sections/contractingForms/customerDataForm/customerDataFormHelper";
import { useTranslation } from "react-i18next";

interface Props extends ContractingSubFormBaseProps {
  degrees: DegreeDTO[];
  disabled?: boolean;
}

const HouseholdDataSubForm = ({ formHandler, degrees, disabled }: Props) => {
  //translations
  const tLabels = useTranslation("contracting\\contracting").t;

  // form hook props
  const { bindDatePickerField, bindFieldNew, errors } = { ...formHandler };

  // render
  return (
    <PageCard
      title={tLabels("householdDataSubForm.cardTitle")}
      bodyClassName="pt-4 px-4"
      cardClassName="mb-4"
    >
      <div className="row no-gutters mx-n2">
        <div className="col-sm-6 px-2">
          <FormGroup
            labelText={tLabels("householdDataSubForm.firstName.label")}
            inputId="firstName"
            validationError={errors["firstName"]}
          >
            <InputGroup
              placement="prepend"
              addonType="select"
              contentElement={
                <DegreeSelect
                  name={"beforeNameDegree"}
                  degrees={degrees}
                  bindField={bindFieldNew}
                  isInFrontOfName
                  disabled={disabled}
                />
              }
            >
              <input
                id={"firstName"}
                className="form-control"
                placeholder={tLabels("householdDataSubForm.firstName.placeholder")}
                {...bindFieldNew("firstName")}
                disabled={disabled}
              />
            </InputGroup>
          </FormGroup>
        </div>
        <div className="col-sm-6 px-2">
          <FormGroup
            labelText={tLabels("householdDataSubForm.surname.label")}
            inputId="surname"
            validationError={errors["surname"]}
          >
            <InputGroup
              addonType="select"
              contentElement={
                <DegreeSelect
                  name={"afterNameDegree"}
                  degrees={degrees}
                  bindField={bindFieldNew}
                  isInFrontOfName={false}
                  disabled={disabled}
                />
              }
            >
              <input
                id={"surname"}
                className="form-control"
                placeholder={tLabels("householdDataSubForm.surname.placeholder")}
                {...bindFieldNew("surname")}
                disabled={disabled}
              />
            </InputGroup>
          </FormGroup>
        </div>
        <div className="col-sm-6 px-2">
          <FormGroup
            labelText={tLabels("householdDataSubForm.dateOfBirth.label")}
            inputId="dateOfBirth"
            validationError={errors["dateOfBirth"]}
          >
            <DatePicker
              {...bindDatePickerField("dateOfBirth")}
              onlySelectable
              showYearsSelect
              maxDate={getDateOfBirthMaxDate()}
              initialVisibleDate={() => getDateOfBirthMaxDate()}
              disabled={disabled}
            />
          </FormGroup>
        </div>
      </div>
    </PageCard>
  );
};

export default HouseholdDataSubForm;
